import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

interface ICurrencyState {
  currency: string;
}

const initialState: ICurrencyState = {
  currency: "USDC",
};

const CurrencySlice = createSlice({
  name: "currency",
  initialState,
  reducers: {
    setCurrency: (state, action: PayloadAction<string>) => {
      state.currency = action.payload;
    },
  },
});

export const { setCurrency } = CurrencySlice.actions;

export default CurrencySlice.reducer;
